<template>
  <v-card>
    <div class="running">
      <div class="running_area">
        <!-- <v-btn class="month_select" @click="prevMonth()">1개월</v-btn> -->
        <v-card class="mt-2">
          <v-row class="pt-2" no-gutters v-if="this.ONOFFYN === 'Y'">
            <v-col cols="5">
              <v-btn class="invControl" v-on:click="inverterOn()">Inverter ON</v-btn>
            </v-col>
            <v-col cols="2" class="d-flex justify-center align-center"></v-col>
            <v-col cols="5">
              <v-btn class="invControl" v-on:click="inverterOff()">Inverter OFF</v-btn>
            </v-col>
          </v-row>
          <v-row class="pt-2" no-gutters>
            <v-col cols="5">
              <v-menu
                v-model="isSDateView"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startDate"
                    dense
                    label="시작일"
                    hide-details
                    outlined
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="startDate" @input="isSDateView = false" no-title></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2" class="d-flex justify-center align-center">~</v-col>
            <v-col cols="5">
              <v-menu
                v-model="isEDateView"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="종료일"
                    dense
                    outlined
                    v-model="endDate"
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="endDate" @input="isEDateView = false" no-title></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-btn
              class="look_btn"
              style="background-color: var(--v-btnbg-base); color: var(--v-cardtextbg-base)"
              @click="search"
            >조회</v-btn>
          </v-row>
        </v-card>
        <v-container fluid class="mt-4 pa-0 ma-0">
          <div id="realgrid" ref="realgrid" class="mb-5 w-full h-64"></div>
        </v-container>
      </div>
    </div>
  </v-card>
</template>

<script>
import { getWorkRecord } from '@/api/pcs/siteWork'
import RealGridJS from 'realgrid/dist/main'
import { getSiteDetail } from '@/api/master/master'
import { getConnect } from '@/api/master/mqtt'

var gridView
var dataProvider
// var listCount = 0 // 받은 정보 리스트 갯수
// var paegSize = 10 // 한페이지당 보여주는 수
// var pageCount = 0 // 총 페이지 갯수

export default {
  props: {
    tabIndex: {
      type: Number,
      default: -1
    },
    SITE_ID: { type: String, default: '' },
    INVERTER_ID: { type: String, default: '' },
    STATION_ID: { type: String, default: '' },
    ONOFFYN: { type: String, default: '' }
  },
  data() {
    return {
      serial: [],
      isSDateView: false,
      isEDateView: false,
      startDate: this.dateFormat(new Date()),
      endDate: this.dateFormat(new Date()),
      nowDate: this.$time(Date.now()).format('YYYY-MM-DD')
      // dateSel: this.$time(Date.now()).format("YYYY-MM-DD"),
      // timeSel: '00:00:00 01:00:00',
    }
  },
  created() {},
  mounted() {
    this.initGrid()
    this.prevMonth()
  },
  methods: {
    inverterOn() {
      if (this.INVERTER_ID == null || this.INVERTER_ID === '') {
        alert('인버터별 탭에서 실행해 주세요')
        return
      }
      let serial = ''
      let params = {
        codenm: this.SITE_ID
      }
      getSiteDetail(params).then(response => {
        const validModels = [
          'HPC-036HL-V1-OU',
          'HPC-036HL-V2-OU',
          'HPC-036HL-V3-OU',
          'HPC-060HL-D1-OU',
          'HPC-060HL-D2-OU',
          'HPC-060HL-D3-OU'
        ]
        const model = response.stations[this.STATION_ID - 1].inverters[this.tabIndex - 1].model
        const serialValue = response.stations[this.STATION_ID - 1].inverters[this.tabIndex - 1].serial
        serial = validModels.includes(model) ? serialValue : '000' + serialValue

        if (confirm('시리얼넘버 ' + serial + ' 인버터를 실행합니다')) {
          let json = null
          let obj2 = null

          let obj = { sn: '0001015642049840' }
          let blob = new Blob([JSON.stringify(obj, null, 2)], {
            type: 'application/json'
          })

          let xhr = new XMLHttpRequest()
          xhr.open(
            'GET',
            'https://api-a.fomware.com/asset/v1/list?key=' +
              serial +
              '&type=2'
          )
          xhr.setRequestHeader('Content-Type', 'application/json')
          // xhr.setRequestHeader('Accept', 'application/json')
          // xhr.setRequestHeader('X-APIVERSION', 'v1.0')
          xhr.setRequestHeader(
            'Authorization',
            'Bearer VOgCWgFeNGNVXCFlCXurfyCEtmdqmkAk'
          )
          xhr.send(blob)
          // let jsondata = JSON.parse(xhr.responseText)
          xhr.onreadystatechange = function() {
            if (xhr.readyState === XMLHttpRequest.DONE) {
              // alert(xhr.responseText)
              // alert(jsondata)
              json = xhr.response
              obj2 = JSON.parse(json)
              console.log(obj2.data.devices[0].deckId)
              console.log(obj2.data.devices[0].xBusId)

              let obj4 = {
                count: 1,
                startAddress: '2700',
                value: '5555',
                deviceCode: [
                  obj2.data.devices[0].deckId +
                    '-' +
                    obj2.data.devices[0].xBusId
                ]
              }
              let blob2 = new Blob([JSON.stringify(obj4, null, 2)], {
                type: 'application/json'
              })

              let xhr2 = new XMLHttpRequest()
              xhr2.open('POST', 'https://api-a.fomware.com/register/v1/write')
              xhr2.setRequestHeader('Content-Type', 'application/json')
              // xhr.setRequestHeader('Accept', 'application/json')
              // xhr.setRequestHeader('X-APIVERSION', 'v1.0')
              xhr2.setRequestHeader(
                'Authorization',
                'Bearer VOgCWgFeNGNVXCFlCXurfyCEtmdqmkAk'
              )
              xhr2.send(blob2)
              // xhr.send(JSON.stringify(obj))
              // let jsondata = JSON.parse(xhr.responseText)
              xhr2.onreadystatechange = function() {
                if (xhr2.readyState === XMLHttpRequest.DONE) {
                  // alert(xhr.responseText)
                  // alert(jsondata)
                  // json = xhr.response
                  // obj2 = JSON.parse(json)
                  // console.log(json)
                  alert('작업 완료. 인버터 적용까지 최대 5분 소요 됩니다.')
                }
              }
            }
          }
        } else {
          alert('실행 취소')
        }
      })
    },
    inverterOff() {
      if (this.INVERTER_ID == null || this.INVERTER_ID === '') {
        alert('인버터별 탭에서 실행해 주세요')
      } else {
        console.log(this.INVERTER_ID)
        console.log(this.INVERTER_ID.substr(5, 2))
        let serial = ''
        let params = {
          codenm: this.SITE_ID
        }
        getSiteDetail(params).then(response => {
          const validModels = [
            'HPC-036HL-V1-OU',
            'HPC-036HL-V2-OU',
            'HPC-036HL-V3-OU',
            'HPC-060HL-D1-OU',
            'HPC-060HL-D2-OU',
            'HPC-060HL-D3-OU'
          ]
          const model = response.stations[this.STATION_ID - 1].inverters[this.tabIndex - 1].model
          const serialValue = response.stations[this.STATION_ID - 1].inverters[this.tabIndex - 1].serial
          serial = validModels.includes(model) ? serialValue : '000' + serialValue

          if (confirm('시리얼넘버 ' + serial + ' 인버터를 종료 합니다')) {
            let json = null
            let obj2 = null

            let obj = { sn: '0001015642049840' }
            let blob = new Blob([JSON.stringify(obj, null, 2)], {
              type: 'application/json'
            })

            let xhr = new XMLHttpRequest()
            xhr.open(
              'GET',
              'https://api-a.fomware.com/asset/v1/list?key=' +
                serial +
                '&type=2'
            )
            xhr.setRequestHeader('Content-Type', 'application/json')
            // xhr.setRequestHeader('Accept', 'application/json')
            // xhr.setRequestHeader('X-APIVERSION', 'v1.0')
            xhr.setRequestHeader(
              'Authorization',
              'Bearer VOgCWgFeNGNVXCFlCXurfyCEtmdqmkAk'
            )
            xhr.send(blob)
            // let jsondata = JSON.parse(xhr.responseText)
            xhr.onreadystatechange = function() {
              if (xhr.readyState === XMLHttpRequest.DONE) {
                // alert(xhr.responseText)
                // alert(jsondata)
                json = xhr.response
                obj2 = JSON.parse(json)
                console.log(obj2.data.devices[0].deckId)
                console.log(obj2.data.devices[0].xBusId)

                let obj4 = {
                  count: 1,
                  startAddress: '2700',
                  value: '7777',
                  deviceCode: [
                    obj2.data.devices[0].deckId +
                      '-' +
                      obj2.data.devices[0].xBusId
                  ]
                }
                let blob2 = new Blob([JSON.stringify(obj4, null, 2)], {
                  type: 'application/json'
                })

                let xhr2 = new XMLHttpRequest()
                xhr2.open(
                  'POST',
                  'https://api-a.fomware.com/register/v1/write'
                )
                xhr2.setRequestHeader('Content-Type', 'application/json')
                // xhr.setRequestHeader('Accept', 'application/json')
                // xhr.setRequestHeader('X-APIVERSION', 'v1.0')
                xhr2.setRequestHeader(
                  'Authorization',
                  'Bearer VOgCWgFeNGNVXCFlCXurfyCEtmdqmkAk'
                )
                xhr2.send(blob2)
                // xhr.send(JSON.stringify(obj))
                // let jsondata = JSON.parse(xhr.responseText)
                xhr2.onreadystatechange = function() {
                  if (xhr2.readyState === XMLHttpRequest.DONE) {
                    // alert(xhr.responseText)
                    // alert(jsondata)
                    // json = xhr.response
                    // obj2 = JSON.parse(json)
                    // console.log(json)
                    alert('작업 완료. 인버터 적용까지 최대 5분 소요 됩니다.')
                  }
                }
              }
            }
          } else {
            alert('실행 취소')
          }
        })
      }
    },
    initGrid() {
      dataProvider = new RealGridJS.LocalDataProvider()
      gridView = new RealGridJS.GridView('realgrid')
      gridView.setDataSource(dataProvider)
      gridView.setRowIndicator({
        visible: false
      })

      // gridView에 옵션을 적용한다.
      gridView.setOptions({
        panel: {
          visible: false
        },
        stateBar: {
          visible: false
        },
        checkBar: {
          visible: false
        },
        indicator: {
          visible: false
        },
        footer: {
          visible: false
        },
        edit: {
          // 데이터 편집
          appendable: false,
          insertable: false,
          deletable: false,
          readOnly: true
        },
        header: {
          // gridView 헤더 설정
          height: 30,
          styles: {
            fontSize: '14',
            fontFamily: 'NanumGothic',
            foreground: '#fff',
            fontBold: 'false',
            background: '#5c97cd',
            selectedBackground: '#9bb2c7',
            borderLeft: '#fff',
            borderRight: '#fff'
          },
          selection: {
            background: '#efefef',
            border: '#ccc,1'
          }
        },
        display: {
          // 그리드 표시 정보 설정
          fitStyle: 'evenFill', // 컬럼 너비 자동 조절
          heightMeasurer: 'fixed',
          rowHeight: 30,
          focusVisible: false, // 클릭시 포커스
          showEmptyMessage: true,
          emptyMessage: ''
        },
        sorting: {
          handleColor: '#fff', // 필터된 헤더 화살표 색상
          hoveredHandleColor: '#fff'
        },
        select: {
          style: 'none' // 선택시 스타일
        }
      })

      // gridView.setStyles({
      //   // gridView 스타일
      //   body: {
      //     fontSize: '14',
      //     fontFamily: 'NanumGothic',
      //     foreground: '#666',
      //     fontBold: 'false',
      //     borderLeft: '#fff,0',
      //     borderRight: '#ccc,1',
      //     borderBottom: '#ccc,1',
      //     empty: {
      //       textAlignment: 'center',
      //       lineAlignment: 'center',
      //       fontSize: 14,
      //       fontBold: false
      //     },
      //     dynamicStyles: [
      //       {
      //         criteria: '(row mod 2) = 0',
      //         styles: {
      //           background: '#F4F4FA'
      //         }
      //       }
      //     ]
      //   }
      // })

      var fields = [
        { fieldName: 'Date', dataType: 'string' },
        { fieldName: 'Time', dataType: 'string' },
        { fieldName: 'Inverter_No', dataType: 'string' },
        { fieldName: 'Run_Status', dataType: 'string' }
      ]
      var columns = [
        {
          name: 'Date',
          fieldName: 'Date',
          header: {
            text: '일자'
          },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'Time',
          fieldName: 'Time',
          header: {
            text: '시간'
          },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'Inverter_No',
          fieldName: 'Inverter_No',
          header: {
            text: '인버터 번호'
          },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'Run_Status',
          fieldName: 'Run_Status',
          header: {
            text: '이력'
          }
        }
      ]
      dataProvider.setFields(fields)
      gridView.setColumns(columns)

      // 컬럼(이력)에서 특정값에 따라 아이콘 변경
      var imageUrl = 'http://' + location.host + '/external/runImage/'
      var imgs = new RealGridJS.ImageList('images1', imageUrl)
      imgs.addUrls(['running_green.png', 'running_red.png'])
      // gridView.registerImageList(imgs)
      // 이미지 리스트에서 사용할 이름 설정
      gridView.setColumnProperty('Run_Status', 'imageList', 'images1')
      // 아이콘 타입의 렌더러 설정
      gridView.setColumnProperty('Run_Status', 'renderer', { type: 'icon' })
      // 아이콘 적용 설정
      var iconSet = this.$refs.realgrid.clientWidth / 8 - 27
      gridView.setColumnProperty('Run_Status', 'styles', {
        iconIndex: 0,
        iconLocation: 'left',
        iconAlignment: 'center',
        iconOffset: iconSet,
        iconPadding: 8
      })
      // dynamictStyles 생성
      var iconStyles = [
        {
          criteria: "value='Run'",
          styles: 'iconIndex=0'
        },
        {
          criteria: "value='Stop'",
          styles: 'iconIndex=1'
        }
      ]
      gridView.setColumnProperty('Run_Status', 'dynamicStyles', iconStyles)
      window.scrollTo(0, 0)
      console.log('0')
    },
    search() {
      if (this.startDate === '' || this.startDate == null) {
        alert('시작일을 선택해 주세요')
        return
      } else if (this.endDate === '' || this.endDate == null) {
        alert('종료일을 선택해 주세요')
        return
      }

      var day = this.$time(this.endDate, 'YYYY-MM-DD').diff(
        this.$time(this.nowDate, 'YYYY-MM-DD'),
        'days'
      )
      var dayReage = this.$time(this.endDate, 'YYYY-MM-DD').diff(
        this.$time(this.startDate, 'YYYY-MM-DD'),
        'days'
      )
      if (day > 0) {
        alert('조회 불가능 날짜입니다.')
        return
      } else if (dayReage > 31) {
        alert('조회기간은 최대 31일까지 입니다.')
        return
      }

      let params = ''
      var sDate = this.$time(this.startDate).format('YYYY-MM-DD')
      var eDate = this.$time(this.endDate).format('YYYY-MM-DD')
      if (this.INVERTER_ID === null || this.INVERTER_ID === '') {
        params =
          '/' + this.SITE_ID + '/' + sDate + '/' + eDate + '/' + 0 + '/' + 0
      } else {
        params =
          '/' +
          this.SITE_ID +
          '/' +
          sDate +
          '/' +
          eDate +
          '/' +
          this.INVERTER_ID +
          '/' +
          this.STATION_ID
      }

      let config = {
        message: 'Load Data...',
        styleName: 'fontSize-18'
      }
      gridView.showToast(config)
      getWorkRecord(params).then(response => {
        // RealGrid에 조회한 데이터를 넣는다.
        dataProvider.fillJsonData(response.workRecord)
        console.log('result', response.workRecord)

        gridView.hideToast()
      })
    },

    prevMonth() {
      // 날짜선택
      this.endDate = this.dateFormat(new Date())
      this.startDate = this.dateFormat(
        new Date().setDate(new Date().getDate() - 6)
      )
    },
    dateFormat(d) {
      const _day = new Date(d)
      const year = _day.getFullYear()
      const mon =
        (_day.getMonth() + 1).toString().length === 1
          ? '0'.toString(1) + (_day.getMonth() + 1)
          : _day.getMonth() + 1
      const da =
        _day.getDate().toString().length === 1
          ? '0'.toString(1) + _day.getDate()
          : _day.getDate()
      console.log(year + '-' + mon + '-' + da)
      return year + '-' + mon + '-' + da
    }
  },
  beforeDestroy: function() {
    // 데이터 초기화
    dataProvider.clearRows()

    // grid, provider 초기화
    gridView.destroy()
    dataProvider.destroy()

    // LocalDataProvider와 GridView 객체 초기화
    gridView = null
    dataProvider = null
  }
}
</script>

<style scoped>
@import '../../../assets/mobile/site.less';

#realgrid {
  height: 100vw;
}

.boxSize {
  text-align: center;
  width: 100%;
  height: 8.4vw;
  padding: 1.5vw;
}
.boxSize input {
  text-align: center;
}
.timeSelect {
  width: 100%;
  background: #ededed;
  padding-top: 1.5vw;
  padding-left: 6vw;
  padding-right: 3vw;
  color: #666;
  font-family: 'hhiLight', 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 4vw;
  font-weight: bold;
}
.running_area {
  margin-top: 0;
}
.fontSize-18 {
  font-size: 32px;
}
.invControl {
  margin-top: 10px;
  margin-bottom: 20px;
}
</style>
